/**
 * @module actions/forsitoken
 */
import axios from 'axios'
import {
  API_URL, FILE_STORAGE_API
} from '../constants'

/**
 * @description Get Forsi draft enums
 * @return {Promise} Axios promise
 */
export function GetForsiDraftEnums () {
  let url = API_URL + `/ForsiToken/Enums/`
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Get Forsi damage types
 * @return {Promise} Axios promise
 */
export function GetForsiDamageTypes (id) {
  let url = API_URL + `/ForsiToken/DamageTypes/${id}`
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Get Forsi draft
 * @return {Promise} Axios promise
 */
export function GetForsiDraft (id) {
  let url = API_URL + `/ForsiToken/Draft/${id}`
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Post Forsi draft
 * @return {Promise} Axios promise
 */
export function CreateForsiDraft (data) {
  let url = FILE_STORAGE_API + `/ForsiToken/Draft/`
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Update Forsi draft
 * @return {Promise} Axios promise
 */
export function UpdateForsiDraft (id, data) {
  let url = API_URL + `/ForsiToken/Draft/${id}`
  return dispatch => {
    return axios.post(url, data)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/forsitoken.js